// Entry point for the build script in your package.json
console.log("LaunchSignal app/javascript/application.js loaded")
import "@hotwired/turbo-rails"
import "cally"
import "./controllers"
